import React, { useContext } from 'react';
import {
  DropdownFilter,
  InputDropdown,
} from 'src/components/dropdown-filter/DropdownFilter';
import { useTranslation } from 'react-i18next';
import { ItemFilter } from 'src/components/dropdown-filter/filter';
import { CheckboxList } from 'src/components/dropdown-filter/CheckboxList';
import { ListContext } from '../context';
import { CardType } from 'src/domain/transaction-management/transactions/transaction';

export const FilterCardType = () => {
  const { dispatch, filters } = useContext(ListContext);

  const { t } = useTranslation();

  const items = [
    CardType.MASTERCARD,
    CardType.VISA,
    CardType.AMEX,
    CardType.DINERS,
    CardType.DISCOVER,
    CardType.JCB,
  ].map((item) => ({
    value: item,
    label: t(`transactionsManagement.transactions.cardType.${item}`),
  }));

  const itemToggle = (options: { checked: boolean; item: ItemFilter }) =>
    dispatch({
      type: options.checked
        ? 'ADD_CARD_TYPE_FILTER'
        : 'REMOVE_CARD_TYPE_FILTER',
      itemFilter: options.item,
    });

  const clearFilter = () => dispatch({ type: 'RESET_CARD_TYPE_FILTER' });

  return (
    <DropdownFilter
      title={t('transactionsManagement.authorizations.list.filters.cardType')}
      headerSecondaryLabel={t(
        'transactionsManagement.transactions.list.filters.numberSelected',
        { totalItems: filters.cardTypes.length }
      )}
      onClearFilter={clearFilter}
      trigger={(dropdownProps) => (
        <InputDropdown
          name="filterCardTypes"
          label={t(
            'transactionsManagement.authorizations.list.filters.cardType'
          )}
          placeholder={t(
            'transactionsManagement.transactions.list.filters.all'
          )}
          value={
            filters.cardTypes.length
              ? t(
                  'transactionsManagement.transactions.list.filters.numberSelected',
                  { totalItems: filters.cardTypes.length }
                )
              : ''
          }
          {...dropdownProps}
        />
      )}
    >
      <CheckboxList
        items={items}
        filters={filters.cardTypes}
        onItemToggle={itemToggle}
        totalItems={filters.cardTypes.length}
        heightClassName="h-auto"
      />
    </DropdownFilter>
  );
};
